<template>
  <div class="logEntry">
    <b-container>
      <b-row>
        <b-col md="6">
          <router-link :to="{ name: 'Entry', params: {entryId: entryId } }">
            <div>
              <b-img :src="graphic" thumbnail fluid class="thumbnail"/>
            </div>
          </router-link>
        </b-col>
        <b-col md="6" class="left">
          <h2>{{title}}</h2>
          <h6 class="indent"> <font-awesome-icon :icon="['far', 'clock']"/> {{displayDate}}</h6>
          <br>
          <p>{{summary}}</p>
          <router-link :to="{ name: 'Entry', params: {entryId: entryId } }" tag="b-button" class="button">Read More</router-link>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'logEntry',
  props: {
    entryId: Number,
    title: String,
    summary: String,
    graphic: String,
    displayDate: String,
    createdBy: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .thumbnail:hover {
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/LogEntry.vue